import { Component } from '@angular/core';
@Component({
  selector: 'frodo-system-ready',
  templateUrl: './system-ready.component.html',
  styleUrls: ['./system-ready.component.scss'],
})
export class SystemReadyComponent {}
